import { useEffect, useMemo, useRef } from 'react';
import throttle from 'lodash/throttle';

const useThrottle = (callback, delay = 1000) => {
    const ref = useRef();

    useEffect(() => {
        ref.current = callback;
    }, [callback]);

    const throttledCallback = useMemo(() => {
        const func = () => ref.current?.();

        return throttle(func, delay);
    }, [delay]);

    return throttledCallback;
};

export default useThrottle;
